import { ContactLink } from './ContactLink';
import { ContactText } from './ContactText';

interface Props {
  contactType: string;
  contactDetail: string;
}

export const ContactTextOrLink = ({ contactType, contactDetail }: Props) => {
  return (
    <>
      {
        {
          email: <ContactLink contactType={contactType} contactDetail={contactDetail} />,
          telephone: <ContactLink contactType={contactType} contactDetail={contactDetail} />,
          text: <ContactText contactDetail={contactDetail} />,
        }[contactType]
      }
    </>
  );
};
